module.exports = __webpack_public_path__ + "static/media/shape0_2.ac2255d9.obj";